<template>

    <div class="picker-wrapper"  :class="{ active : activePicker}">
        <span class="caption ft-xbld">{{ caption }}</span>
        <div class="picker-outer" :class="uniqueClass" ref="outer">
            <div class="dft-preview" @click.prevent="togglePicker">
                <div class="lft">
                    <span class="clr" :style="{ backgroundColor : this.colorTxt }"></span>
                    <span class="txt ft-bld">{{ this.colorTxt }}</span>
                </div>
                <span class="arw" :class="{ spin : activePicker}"></span>
            </div>
            <ChromePicker v-model="color" @input="onColorChange" v-show="activePicker"></ChromePicker>
        </div>
    </div>

</template>

<script>

    import Global from '../lib/GlobalState'

    export default {

        name: 'PickerWrapper',

        props: {
            uniqueClass: String,
            caption: String,
            value: String
        },

        data() {
            return {
                Global,
                color: '',
                colorTxt: '',
                activePicker: false
            }
        },

        mounted() {
            this.colorTxt = this.color = this.value
            document.body.addEventListener('click', this.bodyClick)
        },

        methods: {

            togglePicker() {
                this.activePicker = !this.activePicker
            },

            onColorChange(value) {
                this.colorTxt = value.hex
                this.$emit('input', value.hex)
            },

            setColor(value) {
                this.colorTxt = this.color = value
                this.$emit('input', value)
            },

            bodyClick(event) {
                if (!this.activePicker) return
                let el = '.' + this.$refs.outer.classList[1] + ' *'
                if (!event.target.matches(el))
                    this.activePicker = false
            }
        }
    }
</script>